<script lang="ts" setup></script>

<template>
  <div class="o-skeleton-item o-skeleton-figure"></div>
</template>
